import {
  ListItem,
  Stack,
  Checkbox,
  Input,
  Text,
} from '@ltvco/refresh-lib/theme';
import { CheckBoxOutlineBlank, CheckBox } from '@mui/icons-material';
import React from 'react';

import { composeHOC, withErrorHandling } from '../hoc';

import { StatesSelect } from './components';
import { OptionType } from './utils';

export interface IStateSelectProps {
  id: string;
  states: OptionType[];
  stateInput: OptionType[];
  handleStateChange: (_event: unknown, value: OptionType[]) => void;
}

const SelectComponent = React.memo(
  ({ id, states, stateInput, handleStateChange }: IStateSelectProps) => {
    return (
      <StatesSelect
        id={id}
        multiple
        options={states}
        value={stateInput}
        onChange={handleStateChange}
        getOptionLabel={(option) => option.value}
        disableCloseOnSelect
        disableClearable
        fullWidth
        key={stateInput.length >= 5 ? 'readonly' : 'editable'}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        sx={{
          '& .MuiAutocomplete-input': {
            caretColor: stateInput.length >= 5 ? 'transparent' : 'auto',
          },
        }}
        filterOptions={(options, { inputValue }) =>
          options.filter((option) => {
            const query = inputValue.toLowerCase();
            return (
              option.display.toLowerCase().includes(query) ||
              option.value.toLowerCase().includes(query)
            );
          })
        }
        renderInput={(params) => (
          <Input
            {...params}
            placeholder={
              stateInput.length === 0 ? 'State (Select up to 5)' : ''
            }
          />
        )}
        renderOption={(props, option, { selected }) => (
          <ListItem {...props} key={option.display}>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <Checkbox
                icon={<CheckBoxOutlineBlank sx={{ fontSize: '1.125rem' }} />}
                checkedIcon={<CheckBox sx={{ fontSize: '1.125rem' }} />}
                checked={selected}
              />
              <Text variant="body2">{option.display}</Text>
            </Stack>
          </ListItem>
        )}
      />
    );
  }
);

export const UnclaimedMoneyStatesSelect =
  composeHOC(withErrorHandling)(SelectComponent);
